export function useTgCustomer() {
  return computed(() => {
    const customer = 'https://t.me/trongascom'
    return customer.startsWith('http') ? customer : `https://t.me/${customer}`
  })
}
